import { Box, Button, makeStyles, useTheme } from "@material-ui/core";
import { ProfileDetailsProps } from "../types";
import { Save } from "react-feather";
import BasicDetails from "./components/BasicDetails/BasicDetails";
import Bio from "./components/Bio/Bio";
import Content from "@ds-developer/content";
import PageHeader from "@ds-developer/page-header";
import React from "react";

const useStyles = makeStyles(theme => ({
  pageHeaderWrapper: {
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.up("sm")]: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
    },
    [theme.breakpoints.down("md")]: {
      marginBottom: theme.spacing(2),
    },
  },
  actionButtonWrapper: {
    display: "flex",
    justifyContent: "space-between",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "row",
      justifyContent: "space-between",
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
  },
}));

const ProfileDetails: React.FC<ProfileDetailsProps> = ({
  basicDetails,
  bioValues,
  onAdditionalLanguageChange,
  onDisplayNameChange,
  additionalLanguageOptions,
  onBadgeDateChange,
  onQuestionChange,
  onBackClicked,
  onGenerateBioClick,
  isGeneratingBio,
  isBioGenerationDisabled,
  badgeType,
  errors,
  loading,
}) => {
  const theme = useTheme();
  const classes = useStyles();

  return (
    <Content>
      <Box className={classes.pageHeaderWrapper}>
        <PageHeader
          title="Profile details"
          breadcrumbs={[
            { title: "Home", link: "/" },
            { title: "My business profile", link: "/my-business-profile" },
            { title: "Profile details" },
          ]}
        />
        <Box className={classes.actionButtonWrapper}>
          <Button
            onClick={onBackClicked}
            variant="outlined"
            style={{ marginRight: theme.spacing(2) }}
          >
            Back
          </Button>
          <Button
            color="primary"
            variant="contained"
            type="submit"
            startIcon={<Save size={16} />}
          >
            Save changes
          </Button>
        </Box>
      </Box>
      <BasicDetails
        values={basicDetails}
        additionalLanguageOptions={additionalLanguageOptions}
        onAdditionalLanguageChange={onAdditionalLanguageChange}
        onDisplayNameChange={onDisplayNameChange}
        errors={errors}
        loading={loading}
      />
      <Box mt={4}>
        <Bio
          values={bioValues}
          onBadgeDateChange={onBadgeDateChange}
          onQuestionChange={onQuestionChange}
          onGenerateBioClick={onGenerateBioClick}
          isGeneratingBio={isGeneratingBio}
          isBioGenerationDisabled={isBioGenerationDisabled}
          badgeType={badgeType}
          errors={errors}
          loading={loading}
        />
      </Box>
    </Content>
  );
};

export default ProfileDetails;
